import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography
} from '@mui/material';
import { useState } from "react";
import { useLetras } from '../../../core/hooks/useLetras';
import { IProdutoPedido } from '../../../pedidos/interface/IProdutoPedido';
import { IProduto } from "../../interfaces/IProduto";
import { DrawerPizzaOperacao } from '../DrawerPizzaOperacao';

interface CardPizzaOperacaoProps {
  produto: IProduto;
  adicionarProduto: (produto: IProdutoPedido) => void;
  modoTeclado?: boolean;
  isSelecionado?: boolean;
  onCustomize?: (produto: IProduto) => void;
}

export const CardPizzaOperacao = ({ produto, adicionarProduto, modoTeclado = false, isSelecionado = false, onCustomize }: CardPizzaOperacaoProps) => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  }

  const handleClick = () => {
    if (onCustomize) {
      onCustomize(produto);
    } else {
      toggleDrawer();
    }
  }

  const { maiusculas } = useLetras();

  return (
    <>
      <Card 
        sx={{ 
          maxWidth: 300, 
          height: 250,
          ...(isSelecionado && {
            border: '3px solid',
            borderColor: 'primary.main',
            boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
            transform: 'scale(1.02)',
            transition: 'all 0.2s ease-in-out'
          })
        }} 
        variant='outlined'
        onClick={handleClick}
      >
        <CardActionArea sx={{ height: "100%", width: "100%" }}>
          {produto.imagens?.length ? (
            <CardMedia
              component="img"
              height="140px"
              image={`${produto.imagens[0].url}`}
              sx={{ objectFit: "cover" }}
              alt="Pizza"
            />
          ) : (
            <CardMedia
              component="img"
              height="140px"
              image={`${process.env.PUBLIC_URL}/images/produtos/pizza.png`}
              sx={{ objectFit: "contain" }}
              alt="Pizza"
            />
          )}
          <CardContent sx={{ height: "100%" }}>
            <Typography gutterBottom variant="subtitle1" fontWeight={"bold"} component="div">
              {maiusculas(produto.descricao, 25)}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      {!onCustomize && (
        <DrawerPizzaOperacao
          onSubmit={adicionarProduto}
          toggleDrawer={toggleDrawer}
          produto={produto}
          open={open}
        />
      )}
    </>
  );
}